import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'personalInformation.header',
    description: 'Header for personal information page',
    defaultMessage: 'Do not share my personal information',
  },
  content: {
    id: 'personalInformation.content',
    description: 'Content for personal information page',
    defaultMessage:
      'We will honor your choice to opt-out of sharing personal information for targeted advertising. This choice does not impact your Starbucks Rewards account, app experience, or Starbucks emails and can be managed any time in your account settings. You can further control your collection and use of your personal information by managing your cookie preferences. Please see our { privacyNotice } for more details.',
  },
  manageCookiePreferences: {
    id: 'personalInformation.manageCookiePreferences',
    description: 'Manage cookie preferences button',
    defaultMessage: 'Manage cookie preferences',
  },
  confirmationHeader: {
    id: 'personalInformation.confirmationHeader.header',
    description: 'Header for personal information confirmation page',
    defaultMessage: 'We got your submission',
  },
  confirmationContent: {
    id: 'personalInformation.confirmationContent.content',
    description: 'Content for personal information confirmation page',
    defaultMessage:
      'If this email is in our system, we’ve noted your preferences. You can close or navigate away from this page whenever you’re ready.',
  },
});
